import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "keyboard_arrow_down",
  "use": "keyboard_arrow_down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"keyboard_arrow_down\">\n<title>keyboard_arrow_down</title>\n<path d=\"M7.406 8.578l4.594 4.594 4.594-4.594 1.406 1.406-6 6-6-6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol